import React, { Component } from 'react'
import { FormControl } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

const KedoMonacoEditor = React.lazy(() =>
    import('../../Editors/KedoMonacoEditor')
)

class DefDossierDefFieldCalcSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formula: this.props.item?.settings?.formula ?? '',
        }
    }

    render() {
        return (
            <div>
                <h5>{this.props.kedo.t('Additional settings')}</h5>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Formula')}
                    </FormInputLabel>
                    <KedoMonacoEditor
                        kedo={this.props.kedo}
                        language={'kedoexpr'}
                        originEntity={this.props.defDossier}
                        value={this.state.formula}
                        onChange={(value) => {
                            this.setState({ formula: value })
                            setTimeout(
                                () => this.props.onChange('formula', value),
                                50
                            )
                        }}
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefDossierDefFieldCalcSettings
